/** Prefixo da API: em dev o Vite repassa ao backend; em produção, o ingress. */
const API_BASE = '/api';
/** O backend respondeu com erro (4xx/5xx). */
export class ApiError extends Error {
    status;
    constructor(status, message) {
        super(message);
        this.status = status;
        this.name = 'ApiError';
    }
}
/**
 * A resposta não bate com o contrato: frontend e backend estão em versões
 * diferentes. Falhar aqui, com o caminho do campo, é melhor que um
 * `undefined` aparecendo três telas depois.
 */
export class ContractMismatchError extends Error {
    constructor(path, issues) {
        super(`Resposta de ${path} fora do contrato: ${issues}`);
        this.name = 'ContractMismatchError';
    }
}
async function errorMessage(response) {
    try {
        const body = await response.json();
        if (typeof body === 'object' && body !== null && 'message' in body) {
            return String(body.message);
        }
    }
    catch {
        // Corpo vazio ou que não é JSON: fica a mensagem genérica.
    }
    return `Falha na requisição (${response.status})`;
}
export function createApiClient(getToken) {
    async function request(method, path, schema, body) {
        const token = await getToken();
        const response = await fetch(`${API_BASE}${path}`, {
            method,
            headers: {
                accept: 'application/json',
                ...(body === undefined ? {} : { 'content-type': 'application/json' }),
                ...(token === null ? {} : { authorization: `Bearer ${token}` }),
            },
            ...(body === undefined ? {} : { body: JSON.stringify(body) }),
        });
        if (!response.ok) {
            throw new ApiError(response.status, await errorMessage(response));
        }
        const parsed = schema.safeParse(await response.json());
        if (!parsed.success) {
            throw new ContractMismatchError(path, parsed.error.message);
        }
        return parsed.data;
    }
    return {
        get: (path, schema) => request('GET', path, schema),
        post: (path, body, schema) => request('POST', path, schema, body),
        put: (path, body, schema) => request('PUT', path, schema, body),
        patch: (path, body, schema) => request('PATCH', path, schema, body),
    };
}
/** Para as rotas públicas, chamadas antes de existir token. */
export const publicApi = createApiClient(() => Promise.resolve(null));
//# sourceMappingURL=http-client.js.map